export default {
    tagsView: {
        refresh: '刷新',
        closeOthers: '关闭其他',
        closeAll: '关闭所有',
        close: '关闭',
        allTags: '所有标签页'
    },
    route: {
        index: 'Index',
        dispatchCenter: 'Dispatch Center',
        dispatchOrder: 'Dispatch Order',
        dispatchOrderDetail: 'Dispatch Order Detail',
        receiptSign: 'Receipt Sign',
        transferCreate: 'Transfer Create',
        transferConfirm: 'Transfer Confirm',
        alibabaServices: 'alibaba services',
        taskCenter: 'task center',
        taskCenterDetail: 'task center detail',
        orderCenter: 'order center',
        configCenter: 'config center',
        type: 'config center type',
        charge: 'config center charge',
        distribution: 'config center distribution',
        orderCenterDetail: 'order center detail',
        thirdParty: 'cofing center thirdParty',
        orderSplit: 'cofing center orderSplit',
        billingService: 'cofing center billingService',
        assignment: 'cofing center assignment',
        storehouse: 'storehouse config',
        wms: 'WMS Rules for confirmation of warehouse entry and exit',
        upstream: 'Upstream Depot Rules',
        timeManage: 'time manage',
        agingProduct: 'time manage agingProduct',
        reportManage: 'Report Manage',
        customer: 'config center customer',
        monitorManage: 'monitor manage',
        orderException: 'monitor manage orderException',
        customerPrescription: 'time manage customerPrescription',
        orderWarhouse: 'cofing center orderWarhouse',
        reportIndex: 'report',
        mileage: 'cofing center mileage',
        shipmentQuantity: 'cofing center shipmentQuantity',
        alibabaServicesSingle: 'New Bird Value-added Service List',
        personManage: 'personal platform',
        areaRules: 'Area Rules',
        stockAdjust: 'Stock Adjust Apply',
        virtualCustomer: 'Virtual Customer Manage',
        stockManage: 'Stock Manage',
        inventoryFlow: 'Stock Manage inventoryFlow',
        vehicleManagement: 'vehicle Management',
        reportOMS: 'OMS Opened order report',
        reportWMS: 'WMS Opened order report',
        reportOrder: 'Order tracking report',
        vehicleFreePlatform: 'Vehicle Free Plat Form',
        siteCorrection: 'Site Correction',
        stockCenter: 'stockCenter',
        stockMove: 'stockMove',
        accessStock: 'accessStock',
        omscException: 'omscException',
        orderPanel: 'Order Panel',
        evaluateQuery: 'Evaluate Query',
        transportPage: 'distribute transport page',
        transportDetails: 'distribute transport details',
        inTransitTracking: 'in transit tracking',
        abnormalBilling: 'abnormal billing',
        sieveSingleRule: 'Sieve Single Rule',
        sieveSingleCenter: 'Sieve Single Center',
        singleList: 'Single List',
        singleListDetail: 'Single List Detail',
        limitLineAreas: 'Limit Line Areas',
        algorithmParameters: 'Algorithm Parameters',
        trainList: 'Train List',
        trainListAdjust: 'Train List Adjust',
        trainListDetail: 'Train List Detail',
        appointmentCenter: 'appointment center',
        appointmentCenterDetail: 'appointment center detail',
        basePlatoon: 'base platoon',
        PaymentDurationDetail: 'payment duration detail',
        PaymentDurationMip: 'payment duration mip',
        DriverExpenseManageMip: 'driver expense manage mip',
        visualMapLayout: 'visual Map Layout'
    }
};
